import React from 'react'

const UserSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 16.512 19.264'
    >
      <g
        id='user-svgrepo-com_13_'
        data-name='user-svgrepo-com (13)'
        transform='translate(-2 -1)'
      >
        <path
          id='Path_3178'
          data-name='Path 3178'
          d='M9.128,9.256A4.128,4.128,0,1,0,5,5.128,4.128,4.128,0,0,0,9.128,9.256Z'
          transform='translate(1.128)'
          fill='#b5ccc2'
        />
        <path
          id='Path_3179'
          data-name='Path 3179'
          d='M18.512,13.128A4.128,4.128,0,0,0,14.384,9H6.128A4.128,4.128,0,0,0,2,13.128v4.128H18.512Z'
          transform='translate(0 3.008)'
          fill='#b5ccc2'
        />
      </g>
    </svg>
  )
}

export default UserSvg
